import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/list_containers/packing_house_process/${packing_house_process_id}`
    );
  },

  fetchTemplates(packing_house_id, packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/list_templates/${packing_house_process_id}/${container_id}`
    );
  },

  fetchContainer(packing_house_id, packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/list_templates/container/${packing_house_process_id}/${container_id}`
    );
  }
};
